export default __webpack_public_path__ + "static/media/sign-in-info.1e8747d4.png";